var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VueGtag from 'vue-gtag';
import { BOverlay, BRow, BCol, BFormGroup, BFormInput, BButton, BCard, BAlert } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import FrameVisualisation from 'components/picture-frames/FrameVisualisation.vue';
import StandardSizeSelector from 'components/StandardSizeSelector.vue';
import MountboardColours from 'components/MountboardColours.vue';
import GlazingOptions from 'components/picture-frames/Value/GlazingOptions.vue';
import MouldingOptions from 'components/picture-frames/Value/MouldingOptions.vue';
import FrameDesignSelector from 'components/picture-frames/Value/FrameDesignSelector.vue';
import DiscountsBreakdown from 'components/DiscountsBreakdown.vue';
import FrameSpecification from 'components/picture-frames/Value/FrameSpecification.vue';
import FixingOptions from 'components/picture-frames/Value/FixingOptions.vue';
import { addToCart } from 'ts/modules/cart';
import { checkFrameStock, checkMountStock } from 'ts/modules/stock';
import { getVisualisationUrl } from 'ts/modules/frameDesigner';
import { getVatMode } from 'ts/modules/helpers';
import { validateFrame, validateMount, validateSheet } from 'ts/modules/validation';
import { frameDelivery, sheetDelivery } from 'ts/modules/delivery';
Vue.use(VueGtag, {
    config: { id: "UA-939335-4" }
});
let Value = class Value extends Vue {
    constructor() {
        super(...arguments);
        this.vatMode = 'ex';
        this.loading = true;
        this.loadingPrice = true;
        this.loadingDiscount = true;
        this.loadingStock = true;
        this.quantity = 1;
        this.length = null;
        this.glazing = null;
        this.fixings = 'hanger';
        this.group = null;
        this.selectedBoard = {
            category: { id: 10, name: "Whitecore" },
            category_id: 10,
            description: "The brightest white available in our catalogue.  Whilst not as cold-white as printer paper or cheap mass-produced mountboard, it is a crisp white board with white bevel that suits art paper and high quality photographic prints.",
            id: 102,
            name: "Snow White (8001) ",
            sheet_height: 1120,
            sheet_width: 1630,
            slug: "snow-white-8001",
            stock_lookup_sku: "8001",
            thickness: 1.4
        };
        this.itemSize = {
            width: 210,
            length: 297,
            name: 'A4',
            type: 'a'
        };
        this.frameSize = {
            width: 210,
            length: 297,
            name: 'A4',
            type: 'a'
        };
        this.discountedPrice = '0.00';
        this.discount = 0;
        this.price = "0.00";
        this.exVatPrice = "0.00";
        this.stock = {
            frame: false,
            mount: false
        };
        this.validation = {
            frame: { isValid: true, problems: [], warnings: [] },
            mount: { isValid: true, problems: [], warnings: [] },
            glazing: { isValid: true, problems: [], warnings: [] }
        };
        this.deliveryValidation = {
            frame: { isValid: true, problems: [], warnings: [] },
            glazing: { isValid: true, problems: [], warnings: [] }
        };
        this.debouncedQuantityChange = debounce(this.onQuantityChange, 350);
        this.debouncedUpdatePrice = debounce(this.update, 350);
    }
    get isCollectionOnly() {
        return !this.deliveryValidation.frame.isValid || !this.deliveryValidation.glazing.isValid;
    }
    get isBuyButtonValid() {
        return this.stock.frame
            && this.stock.mount
            && this.validation.frame.isValid
            && this.validation.mount.isValid
            && this.validation.glazing.isValid;
    }
    get isBuyButtonLoading() {
        return this.loading
            || this.loadingPrice
            || this.loadingDiscount
            || this.loadingStock;
    }
    get isBuyButtonDisabled() {
        return !this.isBuyButtonValid || this.isBuyButtonLoading;
    }
    get totalPrice() {
        return (parseFloat(this.discountedPrice.replace(/,/g, '')) * this.quantity).toFixed(2);
    }
    onQuantityChange() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingDiscount = true;
            if (this.quantity == 1) {
                this.discountedPrice = this.price;
                this.discount = 0;
            }
            else {
                let { data } = yield axios
                    .get('/api/pricing/discounts/discountedPrice', {
                    params: {
                        sku: `UVF-${(_a = this.length) === null || _a === void 0 ? void 0 : _a.sku}`,
                        price: this.exVatPrice.replace(/,/g, ''),
                        quantity: this.quantity || 1
                    }
                });
                this.discountedPrice = data.price;
                this.discount = data.discount;
            }
            yield this.checkStock();
            this.loadingDiscount = false;
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingPrice = true;
            yield Promise.all([
                this.updatePrice(),
                this.updateValidation(),
                this.updateDelivery()
            ]);
            this.loadingPrice = false;
        });
    }
    updateDelivery() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [];
            if (this.length) {
                promises.push(frameDelivery(this.length.sku, this.rebateSize)
                    .then(validation => this.deliveryValidation.frame = validation));
            }
            else {
                this.deliveryValidation.frame = { isValid: true, problems: [], warnings: [] };
            }
            if (this.glazing) {
                promises.push(sheetDelivery(`${((_a = this.glazing.category) === null || _a === void 0 ? void 0 : _a.name) == 'Acrylic Glass' ? 'A' : ''}G-${this.glazing.id}`, { width: this.frameSize.width, length: this.frameSize.length }).then(validation => this.deliveryValidation.glazing = validation));
            }
            else {
                this.deliveryValidation.glazing = { isValid: true, problems: [], warnings: [] };
            }
            return Promise.all(promises);
        });
    }
    updateValidation() {
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [];
            if (this.length) {
                promises.push(validateFrame(this.length.sku, this.rebateSize)
                    .then(validation => this.validation.frame = validation));
            }
            if (this.hasMount) {
                promises.push(validateMount(`MCTS-${this.selectedBoard.stock_lookup_sku}`, { width: this.frameSize.width, length: this.frameSize.length }, this.mountOption.borders)
                    .then(validation => this.validation.mount = validation));
            }
            if (this.glazing) {
                promises.push(validateSheet(`G-${this.glazing.id}`, { width: this.frameSize.width, length: this.frameSize.length })
                    .then(validation => this.validation.glazing = validation));
            }
            return Promise.all(promises);
        });
    }
    updatePrice() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let { data } = yield axios
                .get('/api/valueFrames/price', {
                params: {
                    groupID: this.groupId,
                    lengthSku: (_a = this.length) === null || _a === void 0 ? void 0 : _a.sku,
                    rebateWidth: this.rebateSize.width,
                    rebateLength: this.rebateSize.length,
                    glazingID: (_b = this.glazing) === null || _b === void 0 ? void 0 : _b.id,
                    fixings: this.fixings,
                    mountSku: this.hasMount ? this.selectedBoard.stock_lookup_sku : null
                }
            });
            this.price = data.price;
            this.exVatPrice = data.exVatPrice;
            yield this.onQuantityChange();
        });
    }
    get frameDescription() {
        if (this.itemSize.name !== this.frameSize.name) {
            return `${this.frameSize.name} to fit ${this.itemSize.name}`;
        }
        return `${this.itemSize.name} (No Mount)`;
    }
    get mountOption() {
        if (this.itemSize.name !== this.frameSize.name) {
            const yBorder = ((this.rebateSize.length - this.apertureSize.length) - 3) / 2;
            const xBorder = ((this.rebateSize.width - this.apertureSize.width) - 3) / 2;
            return {
                type: 'single',
                top: this.selectedBoard,
                bottom: null,
                reveal: 0,
                borders: {
                    top: yBorder,
                    bottom: yBorder,
                    left: xBorder,
                    right: xBorder
                }
            };
        }
        return {
            type: 'none',
            top: null,
            bottom: null,
            reveal: 0,
            borders: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }
        };
    }
    get artworkSize() {
        return {
            width: Math.min(this.itemSize.width, this.itemSize.length),
            length: Math.max(this.itemSize.width, this.itemSize.length),
            name: this.itemSize.name
        };
    }
    get rebateSize() {
        return {
            width: Math.min(this.frameSize.width, this.frameSize.length) + 3,
            length: Math.max(this.frameSize.width, this.frameSize.length) + 3,
        };
    }
    get apertureSize() {
        return {
            width: this.formattedItemSize.width - 6,
            length: this.formattedItemSize.length - 6
        };
    }
    get formattedItemSize() {
        return {
            width: Math.min(this.itemSize.width, this.itemSize.length),
            length: Math.max(this.itemSize.width, this.itemSize.length)
        };
    }
    get hasMount() {
        return this.itemSize.name !== this.frameSize.name;
    }
    checkStock() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingStock = true;
            if (this.length) {
                this.stock.frame = yield checkFrameStock(`BF-${this.length.sku}`, this.rebateSize, this.quantity);
            }
            else {
                this.stock.frame = true;
            }
            if (this.hasMount) {
                this.stock.mount = yield checkMountStock(`MCTS-${this.selectedBoard.stock_lookup_sku}`, this.rebateSize, this.quantity);
            }
            else {
                this.stock.mount = true;
            }
            this.loadingStock = false;
        });
    }
    addToCart() {
        var _a, _b, _c;
        const item = {
            sku: `UVF-${(_a = this.length) === null || _a === void 0 ? void 0 : _a.sku}`,
            qty: this.quantity,
            attributes: {
                "To Fit": `${this.formattedItemSize.width}x${this.formattedItemSize.length}mm (${this.itemSize.name})`,
                "Internal Frame Size - Rebate Size": `${this.rebateSize.width}x${this.rebateSize.length}mm`,
                "Glass": ((_b = this.glazing) === null || _b === void 0 ? void 0 : _b.name) || '2mm Float Glass',
                "Backing": `2.3mm Craftboard (${this.frameSize.width}x${this.frameSize.length}mm)`,
                "Fixings": this.fixings == 'hanger' ? 'Easy Hanger' : 'Picture Framing Cord and 2 D-Rings Screws',
                "Delivery Available": this.isCollectionOnly ? 'false' : 'true',
                "Image": getVisualisationUrl(((_c = this.length) === null || _c === void 0 ? void 0 : _c.sku) || '', this.rebateSize, this.apertureSize, this.mountOption, true)
            },
            price: this.exVatPrice
        };
        if (this.hasMount) {
            item.attributes['Mount'] = `Single ${this.mountOption.borders.top}x${this.mountOption.borders.left}x${this.mountOption.borders.right}x${this.mountOption.borders.bottom}mm mount (Aperture ${this.apertureSize.width}x${this.apertureSize.length}mm)`;
            item.attributes['Mount Colour'] = this.selectedBoard.name;
        }
        this.$gtag.event('add_to_cart', {
            "items": [
                {
                    "id": item.sku,
                    "name": `${item.sku} - Value Frame`,
                    "brand": "Brampton Framing",
                    "category": "Ultra Value Frames",
                    "quantity": this.quantity,
                    "price": this.exVatPrice
                }
            ]
        });
        addToCart(item, false);
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            // get the group information
            let { data } = yield axios.get('/api/valueFrames/group', { params: { id: this.groupId } });
            this.group = data;
            this.length = this.group.lengths[0];
            this.vatMode = getVatMode();
            this.loading = false;
        });
    }
};
__decorate([
    Prop(Number)
], Value.prototype, "groupId", void 0);
__decorate([
    Watch('quantity')
], Value.prototype, "debouncedQuantityChange", void 0);
__decorate([
    Watch('length', { deep: true }),
    Watch('rebateSize', { deep: true }),
    Watch('glazing', { deep: true }),
    Watch('selectedBoard', { deep: true }),
    Watch('fixings')
], Value.prototype, "debouncedUpdatePrice", void 0);
Value = __decorate([
    Component({
        components: {
            BOverlay, BRow, BCol, BFormGroup, BFormInput, BButton, BCard, BAlert,
            FrameVisualisation, StandardSizeSelector, MountboardColours, GlazingOptions, MouldingOptions, FrameDesignSelector, DiscountsBreakdown, FrameSpecification, FixingOptions
        }
    })
], Value);
export default Value;
